var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy } from '@angular/core';
import { DetailsPageComponent } from './details-page.component';
import { BookedTrip } from '@ibe/models';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '@ibe/store/index';
import { SidebarService, ModalService } from '@ibe/services/ui';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as BookingStepsActions from '@ibe/store/actions/booking-steps.actions';
import { BookingStep } from '@ibe/models/ui';
import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { EXTRAS_ANCILLARY_HOTEL, EXTRAS_ANCILLARY_CAR, EXTRAS_ANCILLARY_CARBON_OFFSET, EXTRAS_ANCILLARY_INSURANCE, EXTRAS_ANCILLARY_TOURS, EXTRAS_ANCILLARY_PERSONAL_ASSISTANCE, EXTRAS_ANCILLARY_PARKING, EXTRAS_ANCILLARY_GUARANTEE_FUND, UK_COUNTRY_CODE, EXTRAS_ANCILLARY_ANIMAL, SSR_CODE_PET_IN_CABIN, EQUIPMENT_CODE_TRAIN, EQUIPMENT_CODE_BUS, ANCILLARY_FOR_FIRST_SEGMENT, SESSION_VAR_KEY_CURRENCY } from '@ibe.config';
import { INDRAGoogleAnalyticsService, EVENT_TIME_TO_THINK_STEP_NO } from '@ibe.services/google.analytics.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { ResetAction } from "@ibe/store/actions/flight-information.indra.actions";
var INDRADetailsPageComponent = /** @class */ (function (_super) {
    __extends(INDRADetailsPageComponent, _super);
    function INDRADetailsPageComponent(router, store, sidebarService, modalService, bfmStorage, bookingSearchService, bookingService, currencyService, flightPriceService, googleAnalytics, storageService, ibeAdminService) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.store = store;
        _this.sidebarService = sidebarService;
        _this.modalService = modalService;
        _this.bfmStorage = bfmStorage;
        _this.bookingSearchService = bookingSearchService;
        _this.bookingService = bookingService;
        _this.currencyService = currencyService;
        _this.flightPriceService = flightPriceService;
        _this.googleAnalytics = googleAnalytics;
        _this.storageService = storageService;
        _this.ibeAdminService = ibeAdminService;
        _this.isAlive = true;
        _this.totalPrice = 0;
        _this.showFillFirstAlert = false;
        _this.isMobile$ = _this.store.select(fromStore.isScreenMobile);
        _this.isMobile = false;
        _this.isLoggedin$ = _this.store.select(fromStore.getLoggedIn);
        _this.userInfo$ = _this.store.select(fromStore.getUserInfo);
        // Data
        _this.bookedTrip$ = _this.store.select(fromStore.getSelectedBookedTrip);
        _this.confirmModalCallback$ = _this.store.select(fromStore.getConfirmModalConfirm);
        _this.confirmModalCallback = '';
        _this.bookingSteps$ = _this.store.select(fromStore.getSelectedBookingSteps);
        _this.bookingSteps = [];
        _this.progressiveSteps = [
            { step: 1, status: false, label: 'Your Account', label_active: 'Your Account' },
            { step: 2, status: false, label: 'Passenger details', label_active: 'Add passenger details' },
            { step: 3, status: false, label: 'Contact details', label_active: 'Add contact details' },
            { step: 4, status: false, label: 'Payment details', label_active: 'Pay' }
        ];
        _this.dates = [];
        _this.allSubs = [];
        _this.flight_tickets = [];
        _this.loadingExtras = true;
        _this.isLoading = true;
        _this.milesInFlightDiscount$ = _this.store.select(fromStore.getMilesInFlightDiscount);
        _this.showInDays = false;
        _this.store.dispatch(new BookingStepsActions.PutCurrentPageAction('timeToThink'));
        _this.currency = _this.currencyService.INDRA_getCurrencySymbol().unit;
        _this.isMobile$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isMobile = value;
        });
        _this.bookedTrip$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.booked_trip = value;
                _this.passengers = value.passengers;
                _this.flights = value.flights;
            }
        });
        _this.confirmModalCallback$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.confirmModalCallback = value;
            }
        });
        _this.bookingSteps$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.bookingSteps = value;
                value.forEach(function (item) {
                    if (item.date)
                        _this.dates.push(item.date);
                });
            }
        });
        _this.milesInFlightDiscount$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.milesInFlightDiscount = value;
            }
        });
        return _this;
    }
    INDRADetailsPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        // check if there is a stored PNR in session storage
        // only call generate dummy PNR API when there is no stored PNR
        // this.bookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
        // if (this.bookedTrip === null) {
        this.timeToThink = this.bfmStorage.INDRA_getTimeToThink();
        if (this.timeToThink && this.timeToThink.validity > 48) {
            this.showInDays = true;
            this.INDRA_formatToDays(this.timeToThink.validity);
        }
        // call generate dummy PNR API
        this.storageService.set('hasLoadedGenerate', false);
        this.pnrSubscription = this.bookingSearchService.INDRA_generateTemporaryPNR().subscribe(function (res) {
            _this.storageService.set('hasLoadedGenerate', true);
            if (res && res.data) {
                // save original structure before massaging the API response
                _this.bfmStorage.INDRA_setOriginalPNRDetailsResponse(res);
                _this.bookedTrip = new INDRABookedTripDetails(res);
                _this.bfmStorage.INDRA_setActiveBookedTrip(_this.bookedTrip);
                _this.INDRA_setFlightTicketsAndFlights();
                _this.flightPrice = _this.INDRA_getFlightPrice();
                _this.loadingExtras = false;
                _this.isLoading = false;
            }
        }, function (err) {
            _this.storageService.set('hasLoadedGenerate', true);
            _this.isLoading = false;
            _this.loadingExtras = false;
        });
        this.allSubs.push(this.pnrSubscription);
    };
    INDRADetailsPageComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRADetailsPageComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    /**
     * Handles a back event from the context menu
     */
    INDRADetailsPageComponent.prototype.INDRA_handleBack = function () {
        var _this = this;
        this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('priceBreakdown.text.backToSelection')));
        this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('priceBreakdown.text.ifYouContinue')));
        this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('priceBreakdown.text.dontLeavePage')));
        this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('priceBreakdown.text.chooseFlightsAgain')));
        this.modalService.assignComponent(INDRAConfirmModalComponent);
        this.modalService.open();
        this.modalService.isOpen
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (!value) {
                if (_this.confirmModalCallback === 'ok') {
                    _this.INDRA_clearBookedTrip();
                    _this.store.dispatch(new ConfirmModalActions.ResetAction);
                    _this.store.dispatch(new ResetAction());
                    if (_this.booked_trip.stopover) {
                        _this.router.navigate(['/booking/flights-stopover']);
                    }
                    else {
                        if (_this.booked_trip.booking_type === 'M') {
                            _this.router.navigate(['/booking/flights-multicity']);
                        }
                        else {
                            _this.router.navigate(['/booking/flights']);
                        }
                    }
                }
            }
        });
    };
    INDRADetailsPageComponent.prototype.INDRA_clearBookedTrip = function () {
        var auxArray = [];
        this.bookingSteps.forEach(function (step) { auxArray.push(Object.assign(new BookingStep(null, null), step, { flight_selected: false })); });
        var booked_trips = Object.assign(new BookedTrip([], this.booked_trip.pnr, this.booked_trip.booking_type), this.booked_trip);
        booked_trips.emptyFlights();
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(booked_trips));
        this.store.dispatch(new BookingStepsActions.PutStepsAction(auxArray));
        this.store.dispatch(new BookingStepsActions.PutCurrentStepAction(0));
    };
    INDRADetailsPageComponent.prototype.INDRA_getFlightPrice = function () {
        if (this.booked_trip.flights.length) {
            var totalFlightCost = this.flightPriceService.INDRA_getBookingTotalCost(this.booked_trip.flights, this.booked_trip.booking_type, false, false, [], [], null, [], [], null);
            var newTotalFlightCost = '';
            var discounted = false;
            if (this.milesInFlightDiscount && this.milesInFlightDiscount.miles && this.milesInFlightDiscount.cash) {
                var flightCost = this.flightPriceService.computeSelectedFlightsTotalPrice(this.booked_trip.flights, this.booked_trip.booking_type, false);
                newTotalFlightCost = this.milesInFlightDiscount.miles.toFixed(0) + ' M + ' + (flightCost - this.milesInFlightDiscount.cash).toFixed(2) + ' ' + this.currency;
                discounted = true;
            }
            return { totalFlightCost: discounted ? newTotalFlightCost : totalFlightCost, oldTotalFlightCost: totalFlightCost, discounted: discounted };
        }
        else {
            return;
        }
    };
    INDRADetailsPageComponent.prototype.INDRA_handlePriceBreakDown = function () {
        this.sidebarService.openSidebar(['price-breakdown-ttt']);
    };
    INDRADetailsPageComponent.prototype.INDRA_handleSelect = function () {
        this.router.navigateByUrl('/booking/time-to-think/payment');
        this.INDRA_registerGACheckoutFlight();
    };
    INDRADetailsPageComponent.prototype.INDRA_setFlightTicketsAndFlights = function () {
        var _this = this;
        // const flight_sections = [];
        this.INDRA_initializeFlightTicketObjects();
        var key = 0;
        // outbound flights
        this.bookedTrip.data.fare.listOutbound.forEach(function (outbound) {
            /*this.outboundCarriers = outbound.listSegment.every( segment => {
                return segment.carrier === 'TP';
            });*/
            // const outboundLength = outbound.listSegment.length;
            // const outboundSegments = this.INDRA_getSegmentIDs(outbound);
            _this.flight_tickets.push({
                type: 'flight',
                id: 'flight-' + key,
                item: {
                    details: outbound,
                    departureLocation: _this.bookedTrip.translate.locations[outbound.listSegment[0].departureAirport],
                    arrivalLocation: _this.bookedTrip.translate.locations[_this.bookingService.INDRA_getLastSegmentFlightIgnoringTrain(outbound.listSegment)['arrivalAirport']],
                    airLinesTranslation: _this.bookedTrip.translate.airlines,
                    extras: [] // this.INDRA_filterExtras(outbound.idFlight, outbound.assignedFlightId, outboundSegments)
                },
            });
            key++;
        });
        // inbound flights
        if (this.bookedTrip.data.fare.listInbound) {
            this.bookedTrip.data.fare.listInbound.forEach(function (inbound) {
                _this.flight_tickets.push({
                    type: 'flight',
                    id: 'flight-' + key,
                    item: {
                        details: inbound,
                        departureLocation: _this.bookedTrip.translate.locations[_this.bookingService.INDRA_getFirstSegmentFlightIgnoringTrain(inbound.listSegment)['departureAirport']],
                        arrivalLocation: _this.bookedTrip.translate.locations[_this.bookingService.INDRA_getLastSegmentFlightIgnoringTrain(inbound.listSegment)['arrivalAirport']],
                        airLinesTranslation: _this.bookedTrip.translate.airlines,
                        extras: []
                    }
                });
                key++;
            });
        }
        this.bfmStorage.INDRA_setFlightTickets(this.flight_tickets);
    };
    INDRADetailsPageComponent.prototype.INDRA_initializeFlightTicketObjects = function () {
        this.flight_tickets = [];
    };
    INDRADetailsPageComponent.prototype.INDRA_updateFlightTicketsExtras = function (extras) {
        var _this = this;
        this.extrasAncillaries = extras;
        this.flight_tickets.filter(function (tkt) { return tkt.type == 'flight'; }).forEach(function (flightItem) {
            flightItem.item.extras = _this.INDRA_filterExtras(flightItem.item.details.idFlight, flightItem.item.details.assignedFlightId, _this.INDRA_getSegmentIDs(flightItem.item.details), flightItem.item);
        });
    };
    INDRADetailsPageComponent.prototype.INDRA_getSegmentIDs = function (flightItem) {
        return flightItem.listSegment.map(function (segment) { return segment.idInfoSegment + ''; });
    };
    INDRADetailsPageComponent.prototype.INDRA_filterExtras = function (idFlight, assignedFlightId, segmentIDs, flightItem) {
        var ancillaryList = [];
        if (this.extrasAncillaries && this.extrasAncillaries.bundleList) {
            this.extrasAncillaries.bundleList.forEach(function (bundle) {
                bundle.ancillaryList.forEach(function (ancillary) {
                    if (ancillary.type
                        && ancillary.type != EXTRAS_ANCILLARY_HOTEL
                        && ancillary.type != EXTRAS_ANCILLARY_CAR
                        && ancillary.type != EXTRAS_ANCILLARY_INSURANCE
                        && ancillary.type != EXTRAS_ANCILLARY_TOURS
                        && ancillary.type != EXTRAS_ANCILLARY_PERSONAL_ASSISTANCE
                        && ancillary.type != EXTRAS_ANCILLARY_PARKING
                        && ancillary.type != EXTRAS_ANCILLARY_CARBON_OFFSET
                        && ancillary.type != EXTRAS_ANCILLARY_GUARANTEE_FUND) {
                        ancillary.catalog.forEach(function (catalog) {
                            // tslint:disable-next-line:radix
                            catalog.flightId = parseInt(catalog.flightId.toString());
                            if (catalog.flightId === idFlight && segmentIDs.includes(catalog.segmentId.toString())) {
                                catalog.passengers.forEach(function (passenger) {
                                    if (passenger.codeList.length > 0) {
                                        if (!ancillaryList.includes(ancillary.type)) {
                                            if (flightItem) {
                                                var isToUK = flightItem.arrivalLocation.countryCode === UK_COUNTRY_CODE;
                                                if (isToUK && ancillary.type === EXTRAS_ANCILLARY_ANIMAL) {
                                                    passenger.codeList.forEach(function (code) {
                                                        if (code.code !== SSR_CODE_PET_IN_CABIN) {
                                                            if (!ancillaryList.includes(ancillary.type)) {
                                                                ancillaryList.push(ancillary.type);
                                                            }
                                                        }
                                                    });
                                                }
                                                else {
                                                    ancillaryList.push(ancillary.type);
                                                }
                                            }
                                            else {
                                                ancillaryList.push(ancillary.type);
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            });
        }
        return ancillaryList;
    };
    /**
     * Get all flight tickets (flights and other cards - eg. Stopover)
     */
    INDRADetailsPageComponent.prototype.INDRA_getFlightTickets = function () {
        return this.flight_tickets;
    };
    // filters the ancillary catalog to exclude specific catalog types not associated with the first flight segment of a flight
    INDRADetailsPageComponent.prototype.INDRA_filterAncillaryFirstSegmentOnly = function (bundleList) {
        var _this = this;
        this.bookedTrip.data.fare.listOutbound.forEach(function (flight) {
            var firstSegmentID = _this.INDRA_getFirstFlightSegmentID(flight);
            bundleList = _this.INDRA_catalogRemover(bundleList, flight.idFlight, firstSegmentID, _this.INDRA_getSegmentIDs(flight));
        });
        this.bookedTrip.data.fare.listInbound.forEach(function (flight) {
            var firstSegmentID = _this.INDRA_getFirstFlightSegmentID(flight);
            bundleList = _this.INDRA_catalogRemover(bundleList, flight.idFlight, firstSegmentID, _this.INDRA_getSegmentIDs(flight));
        });
        return bundleList;
    };
    INDRADetailsPageComponent.prototype.INDRA_getFirstFlightSegmentID = function (flight) {
        var firstSegmentID;
        if (flight.listSegment && flight.listSegment.length > 0) {
            var flightOnlySegments = flight.listSegment.filter(function (segment) {
                return segment.equipment !== EQUIPMENT_CODE_TRAIN && segment.equipment !== EQUIPMENT_CODE_BUS;
            });
            if (flightOnlySegments && flightOnlySegments.length > 0) {
                firstSegmentID = flightOnlySegments[0].idInfoSegment;
            }
        }
        return firstSegmentID;
    };
    INDRADetailsPageComponent.prototype.INDRA_catalogRemover = function (bundleList, flightID, segmentID, segmentIDs) {
        bundleList.forEach(function (bundleItem, bundleIndex) {
            bundleItem.ancillaryList.forEach(function (ancillary, ancillaryIndex) {
                if (ANCILLARY_FOR_FIRST_SEGMENT.includes(ancillary.type)) {
                    var newCatalog = ancillary.catalog.filter(function (catalogItem) {
                        return !(catalogItem.flightId == flightID &&
                            catalogItem.segmentId != segmentID &&
                            segmentIDs.includes(catalogItem.segmentId.toString()));
                    });
                    bundleList[bundleIndex].ancillaryList[ancillaryIndex].catalog = newCatalog;
                }
            });
        });
        return bundleList;
    };
    INDRADetailsPageComponent.prototype.INDRA_registerGACheckoutFlight = function () {
        var isEcommerce = true;
        var origin = this.googleAnalytics.IBE_getOriginAirport(null, isEcommerce);
        var dest = this.googleAnalytics.IBE_getDestinationAirport(null, null, isEcommerce);
        var flightCode = origin + "-" + dest;
        var flightName = origin + "-" + dest;
        var price = this.timeToThink.totalFee;
        var eventDataLayerObject = this.googleAnalytics.IBE_createGA_FlightProducts(flightCode, flightName, undefined, undefined, price);
        eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(undefined, EVENT_TIME_TO_THINK_STEP_NO);
        this.googleAnalytics.INDRA_GA_checkout(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
    };
    INDRADetailsPageComponent.prototype.INDRA_formatToDays = function (validity) {
        var days = validity / 24;
        this.timeToThink.validity = days;
    };
    return INDRADetailsPageComponent;
}(DetailsPageComponent));
export { INDRADetailsPageComponent };
